<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          Edit License Manager
          <v-btn icon @click="$router.push('/license-manager')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <div v-if="loading" style="text-align:center; margin-top: 16px;">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <v-form v-show="!loading" v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Name *</label></v-col
              >
              <v-col sm="8">
                <v-text-field v-model="name" :rules="nameRules" filled autofocus/>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Email *</label></v-col
              >
              <v-col sm="8">
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  filled
                  disabled
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Role *</label></v-col
              >
              <v-col sm="8">
                <!-- <v-text-field filled v-model="role"></v-text-field> -->
                <v-select
                  v-model="role"
                  :item-text="(item) => item.role_name"
                  :items="roleList"
                  :item-value="(item) => item.id"
                  filled
                  append-icon="expand_more"
                  label="Select"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  :disabled="
                    !valid ||
                    name === null ||
                    email === null ||
                    role === null ||
                    name === '' ||
                    email === ''
                  "
                  class="primary_btn small"
                  :loading="saveBtnloading"
                  depressed
                  @click="update"
                  >Save</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import { storeActions } from '@/store/actions.constants';

export default {
  data: () => ({
    loading: true,
    saveBtnloading: false,
    valid: false,
    name: null,
    email: null,
    role: null,
    user_id: null,
    roleList: [],
    nameRules: [
      (v) => !!v?.trim() || 'Name required',
      (v) =>
        /^[A-Za-z ]{3,20}$/.test(v?.trim()) ||
          'Name should contain character only and length should be 3 to 20',
    ],
    emailRules: [
      (v) => !!v || 'Email required',
      (v) => /@.+\..+/.test(v) || 'Invalid email',
    ],
  }),

  async mounted() {
    this.loading = true;
    let res = await this.getRoleList();

    this.roleList = res.data;
    let id = this.$route.params.id;

    this.getByid(id);
    this.loading = false;
  },
  methods: {
    ...mapActions({
      updateLicenseManager: 'addLicenseManager/updateLicenseManager',
      getRoleList: 'addLicenseManager/getRoleList',
      getLicenseManagerById: 'addLicenseManager/getLicenseManagerById',
      getLicenseManagers: 'addLicenseManager/getLicenseManagerDetails',
    }),
    getByid(id) {
      let licenseObj = {
        customer_id: id,
      };
      this.user_id = id;
      // this.$store.dispatch(`users/${storeActions.loginAction}`, usrObj).then((res) => console.log(res))
      this.getLicenseManagerById(licenseObj)
        .then((res) => {
          //     this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          //   text: res.data.message,
          //   timeout: 1000,
          //   color: "success",
          // });

          this.email = res.data.email;
          this.role = this.roleList.filter(
            (el) => el.role_name === res.data.role_name,
          )[0];
          this.name = res.data.name;
          return res;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          // Skip login until API and schema got finalise
          console.error(err);
        });
    },
    update() {
      this.saveBtnloading = true;
      const licenseManagerObj = {
        name: this.name,
        email: this.email,
        roleId: typeof this.role === 'object' ? this.role.id : this.role,
        user_id: this.user_id,
      };
      // this.$store.dispatch(`users/${storeActions.loginAction}`, usrObj).then((res) => console.log(res))

      this.updateLicenseManager(licenseManagerObj)
        .then(async (res) => {
          this.saveBtnloading = true;
          this.$router.push('/license-manager');
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: res.data.message,
            timeout: 1000,
            color: 'success',
          });
          if (res.status === 200) {
            await this.getLicenseManagers();
            this.saveBtnloading = false;
            this.$router.push('/license-manager');
          }
        })
        .catch((err) => {
          this.saveBtnloading=false;
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          // Skip login until API and schema got finalise
          //   this.$router.push('/license-manager');
          console.error(err);
        });
    },
  },
};
</script>
